import CloseIcon from '@mui/icons-material/Close';
import { Chip, darken, lighten, styled } from '@mui/material';
import type { ChipProps } from '@mui/material/Chip';
import { customColorPalette } from '@orcha/micro-library-core-ui';

export type AppliedFilterChipProps = ChipProps & object;

const StyledChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  '&.MuiChip-outlined': {
    color: theme.palette.secondary.main,
    border: `1px solid ${customColorPalette.blueGreyDark}`,
    '& .MuiSvgIcon-root': {
      color: customColorPalette.blueGreyDark,
      '&:hover': {
        color: lighten(customColorPalette.blueGreyDark, 0.2),
      },
    },
  },
  '&.MuiChip-filled': {
    background: customColorPalette.blueGreyDark,
    color: theme.palette.common.white,
    '& .MuiSvgIcon-root': {
      color: theme.palette.common.white,
      '&:hover': {
        color: darken(theme.palette.common.white, 0.2),
      },
    },
  },
}));

/**
 * AppliedFilterChip component from [MicroLibrarySearchUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibrarySearchUI)
 * @param {AppliedFilterChipProps} props - The props for the AppliedFilterChip component.
 * @returns {React.ReactElement} The AppliedFilterChip component.
 */

export const AppliedFilterChip = ({ ...props }: AppliedFilterChipProps) => {
  return <StyledChip deleteIcon={<CloseIcon />} {...props} />;
};
